import { motion } from "framer-motion";

const ORANGE = "#E8470A";

export function DestinationCTA({ destination, ctaImage }) {
  return (
    <section style={{
      position: "relative",
      borderRadius: "20px",
      overflow: "hidden",
      padding: "96px 24px",
      backgroundImage: `url(${ctaImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}>
      <div style={{
        position: "absolute",
        inset: 0,
        backgroundColor: "rgba(23,32,51,0.72)",
      }} />

      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        viewport={{ once: true, margin: "-80px" }}
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: "600px",
          margin: "0 auto",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <span style={{
          color: ORANGE,
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "0.28em",
          textTransform: "uppercase",
        }}>
          Reservá con Alohar
        </span>

        <h2 style={{
          fontSize: "clamp(28px, 4vw, 44px)",
          fontWeight: 800,
          color: "#ffffff",
          lineHeight: 1.15,
          margin: 0,
        }}>
          Descubrí los mejores alojamientos en {destination}
        </h2>

        <p style={{
          fontSize: "16px",
          lineHeight: 1.65,
          color: "rgba(255,255,255,0.65)",
          margin: 0,
          maxWidth: "480px",
        }}>
          Encontrá cabañas, departamentos y casas con todo lo que necesitás para
          disfrutar {destination} al máximo. Reservá de forma segura y sin sorpresas.
        </p>

        <a
          href="#alojamientos"
          style={{
            display: "inline-flex",
            alignItems: "center",
            backgroundColor: ORANGE,
            color: "#ffffff",
            fontWeight: 700,
            fontSize: "16px",
            padding: "14px 32px",
            borderRadius: "999px",
            textDecoration: "none",
            boxShadow: "0 8px 32px rgba(232,71,10,0.4)",
            marginTop: "4px",
          }}
        >
          Buscar alojamientos
        </a>
      </motion.div>
    </section>
  );
}
